<template>
  <v-data-iterator :items="feeds" hide-actions>
    <template v-slot:header>
      <h1>New/Pending Issues</h1>
    </template>

    <template v-slot:item="feed">
      <v-container fluid>
        <v-layout row>
          <v-flex xs2>
            <div>Incident ID</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.incident_id }}</div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <div>Application/Job/Interface Name</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.name }}</div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <div>Time Reported</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.notification_time }}</div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <div>Report Method</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.report_method }}</div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs2>
            <div>Outage Associated with Incident</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.outage }}</div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs2>
            <div>Message</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.message }}</div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <div>Description</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.description }}</div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs2>
            <div>Business Region(s) Impact</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.location_impact }}</div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <div>Business Unit(s) Impact</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.business_impact }}</div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs2>
            <div>Company Impact</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.company_impact }}</div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs2>
            <div>IT Team Escalation(s)</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.escalated_teams }}</div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs2>
            <div>CPR Notified</div>
          </v-flex>
          <v-flex xs6>
            <div>{{ feed.item.cpr_notified }}</div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="feed.item.notifications"
              hide-actions
            >
              <template v-slot:items="log">
                <td>{{ log.item.date }}</td>
                <td>{{ log.item.next_update }}</td>
                <td>{{ log.item.status }}</td>
                <td>{{ log.item.resolution }}</td>
                <td>{{ log.item.root_cause }}</td>
                <td>{{ log.item.time_resolved }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider />
    </template>

    <template v-slot:footer>
      <h1>Resolved in Last 48 Hours</h1>
    </template>
  </v-data-iterator>
</template>

<script>
export default {
  props: ["feeds", "headers"]
};
</script>
